import React from 'react';
import SVGInline from 'react-svg-inline';

// icons
import greyMugicGlassesSVG from "../../../inlineSVGs/greyMugicGlassesSVG";

// styles
import './CircleAvatar.css';

// for now no actual image only default avatar - tbd
const CircleAvatar = () => {
    return (
        <div className="circle-avatar-wrapper">
            <div className="circle">
                <SVGInline svg={greyMugicGlassesSVG} width="60px" color="white" className="close" />
            </div>
        </div>
    )
};

export default CircleAvatar;



// WEBPACK FOOTER //
// ./src/Components/Elements/Avatars/CircleAvatar/CircleAvatar.js